import FeedStructure from "../../Constants/feedStructure"; // Import the structure

export const fetchFeedData = async () => {
  try {
    const response = await fetch("/api/mock/UserAccount/UserAccountFeedContentMockapi.json"); // Fetch from public folder
    const data = await response.json();

    // Ensure data follows FeedStructure
    const formattedData = data.map((user) => ({
      userId: user.userId || "",
      posts: (user.posts || []).map((feed) => ({
        postId: feed.postId || "",
        descriptions: feed.descriptions || "",
        timestamp: feed.timestamp || "",
        location: feed.location || "",
        nlikes: feed.nlikes || 0,
        medias: (feed.medias || []).map((media) => ({
          mediatype: media.mediatype || "",
          mediaurl: media.mediaurl || "",
          nlikes: media.nlikes || 0,
          likes: (media.likes || []).map((like) => ({
            userId: like.userId || "",
            timestamp: like.timestamp || "",
          })),
          comments: (media.comments || []).map((comment) => ({
            userId: comment.userId || "",
            comment: comment.comment || "",
            timestamp: comment.timestamp || "",
            location: comment.location || "",
          })),
          nshares: media.nshares || 0,
          shares: (media.shares || []).map((share) => ({
            userId: share.userId || "",
            platform: share.platform || "",
            timestamp: share.timestamp || "",
          })),
          nsuggests: media.nsuggests || 0,
          suggests: (media.suggests || []).map((suggest) => ({
            suserId: suggest.suserId || "",
            tuserid: suggest.tuserid || "",
            sprofileid: suggest.sprofileid || "",
            tprofileid: suggest.tprofileid || "",
            timestamp: suggest.timestamp || "",
          })),
        })),
        likes: (feed.likes || []).map((like) => ({
          userId: like.userId || "",
          timestamp: like.timestamp || "",
        })),
        comments: (feed.comments || []).map((comment) => ({
          userId: comment.userId || "",
          comment: comment.comment || "",
          timestamp: comment.timestamp || "",
          location: comment.location || "",
        })),
        nshares: feed.nshares || 0,
        shares: (feed.shares || []).map((share) => ({
          userId: share.userId || "",
          platform: share.platform || "",
          timestamp: share.timestamp || "",
        })),
      })),
    }));

    return formattedData;
  } catch (error) {
    console.error("Error fetching feed data:", error);
    return [];
  }
};

export default fetchFeedData